<template>
  <div>
    <div class="head">
      <div class="headbar">
        <div class="container">
          <div class="head-lt">
            <a>欢迎回来到沃德珠宝！</a>
          </div>
          <div class="head-md webCSS">
            <marquee direction="left">
              温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
              1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
              2、实际到货后， 货品“地点”将变更为”HK”。
              3、下单即视为可以接受货品7个工作日之内到港。
              4、货品质量与香港现货库存一致。
            </marquee>
          </div>
        </div>
      </div>
      <div class="head-nav">
        <div class="header">
          <div class="header-lt">
            <div class="logo">
              <a href>
                <img src="/static/img/img/logo.png" />
              </a>
            </div>
          </div>
          <div class="header-ce">
                    <div class="nav">
                        <ul>
                           <li @click="goPage('Home')">首页</li>
                            <li @click="goPage('DiamondSearch')">GIA裸钻</li>
                            <li @click="goPage('MyCar')">我的购物车</li>
                            <li @click="goPage('MyOrder')">我的订单</li>
                            <li @click="goPage('Calculator', true)">计算器</li>
                            <li @click="goPage('FeedBack', true)">问题反馈</li>
                            <li @click="goPage('ChangePass')">修改密码</li>
                            <li @click="loginOut">注销登录</li>
                        </ul>
                    </div>
                </div>
        </div>
      </div>
    </div>
    <div class="war">
        <img src="/static/img/img/brs1.png" class="login-img" />
        <div class="container" slot="container">
            <div class="login_gird">
                <fieldset class="fslogin webCSS">修改密码</fieldset>
                <hr class="mgtop webCSS" />
                <fieldset class="fslogin ">
                    <input class="changepass" :type="options.showPassword1 ? 'text' : 'password'" v-model="pageFrom.password" placeholder="原密码" />
                    <div class="extend-from-button" @click="onChangeShowPassword('showPassword1')">{{options.showPassword1 ? '隐藏' : '显示'}}</div>
                </fieldset>
                <fieldset class="fslogin">
                    <input class="changepass" :type="options.showPassword2 ? 'text' : 'password'" v-model="pageFrom.confirm_password " placeholder="新密码">
                    <div class="extend-from-button" @click="onChangeShowPassword('showPassword2')">{{options.showPassword2 ? '隐藏' : '显示'}}</div>
                </fieldset>
                <fieldset class="fslogin btn_login">
                    <div class="extend-from-notes">可使用数字,字母,下划线组合, 且长度为6-18字符</div>
                    <div class="extend-button-container">
                        <div class="extend-button" :class="isPasswordLength && 'active'" @click="onResetPassword()">完成</div>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
    <div class="board" style="display: none">
      <div class="board_title">
        <i class="fa fa-file-audio-o" aria-hidden="true"></i>公告栏
        <span>Notice Board</span>
        <a class="board_close"></a>
      </div>
      <p>
        温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
        1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
        2、实际到货后， 货品“地点”将变更为”HK”。
        3、下单即视为可以接受货品7个工作日之内到港。
        4、货品质量与香港现货库存一致。
      </p>
    </div>
  </div>
</template>
<script>
    import Core from '@/until/core'
    import ScrollPullDown from '@/public/ScrollPullDown'
    import SideMenu from '@/public/SideMenu'
    export default {
        name: 'ChangePass',
        data () {
            return {
                options: {
                    SideMenu: false,
                    showPassword1: false,
                    showPassword2: false,
                    accessToken: ''
                },
                pageFrom: {
                    password: '',
                    confirm_password: ''
                }
            }
        },
        components: {
            ScrollPullDown,
            SideMenu
        },
        watch: {},
        computed: {
            staffCurrent () {
                return this.$store.state.staffData || {}
            },
            isPasswordLength () {
                return String(this.pageFrom.confirm_password || '').length >= 6
            }
        },
        filters: {},
        methods: {
            goPage (name, bool) {
                const that = this
                if (bool) {
                    return Core.goNext(name, that.$route.params)
                }
                Core.loginExist().then(res => {
                    if (res) {
                        return Core.goNext(name, that.$route.params)
                    }
                    Core.goNext('StaffLogin', that.$route.params)
                })
            },
            loginOut () {
                Core.onRemoveToken()
                Core.goNext('StaffLogin', this.$route.params, true)
            },
            onSideMenu (state) {
                this.options.SideMenu = false
            },
            goBack () {
                Core.goBack()
            },
            onResetPassword () {
                // 重置密码
                const that = this
                const param = {
                    database: {
                        // realname: that.staffCurrent.realname,
                        password: that.pageFrom.password,
                        new_password: that.pageFrom.confirm_password,
                        confirm_password: that.pageFrom.confirm_password
                    }
                }
                that.$store.commit('onChangeAppLoaderShow', true)
                Core('Api/Staff/CurrentUpdate', param).then(body => {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    if (!body.data.error_code && body.data.data) {
                        this.$router.back()
                        return that.$store.commit('onChangeAppMessage', body.data.data)
                    }
                    that.$store.commit('onChangeAppMessage', body.data.error_msg || '操作失败')
                })
            },
            onChangeShowPassword (keys) {
                const that = this
                if (Object.prototype.hasOwnProperty.call(that.options, keys)) {
                    that.options[keys] = !that.options[keys]
                }
            }
        },
        mounted () {}
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import "../../node_modules/swiper/dist/css/swiper.min.css";
@import "../../static/css/yellow.css";
@import "../../static/css/font-awesome.css";
.nav{ height: 90px; }
.header-ce{ width:1000px; }
.header-ce ul li{ float: left; line-height: 90px; width:100px; text-align: center;}
.Home-banner {
  width: 100%;
  height: 600px;
  overflow: hidden;
  background-color: #fff;
}
.btn-hk {
  color: #fff;
  padding: 8px 16px;
  line-height: 100px;
  background: #f268a3;
  border-radius: 2px;
  font-size: 13px;
}

.modelBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  z-index: 999;
}

.model {
  position: absolute;
  width: 1000px;
  height: 500px;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: calc(50% - 350px);
  z-index: 9999;
  text-align: center;
  padding: 50px 0;
}

.closed {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  right: 150px;
  top: 120px;
  text-align: center;
  line-height: 22px;
  background: #e0b12f;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.timeer {
  text-align: center;
  position: absolute;
  bottom: 0;
  width: 100px;
  margin: auto;
  left: 0;
  right: 0;
  line-height: 40px;
  font-size: 14px;
  color: #ffeb3b;
  font-size: 30px;
  border-radius: 5px;
}
.login-main {
  padding: 0.4rem 0.26rem;
}
.login-info {
  width: 100%;
  height: 1rem;
  border-bottom: 1px solid #ebebeb;
  padding: 0 0.15rem;
  font-size: 0.3rem;
  line-height: 0.98rem;
}
.login-info-input {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
  outline: none;
}
.login-btn {
  width: 100%;
  height: 1rem;
  margin-top: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.32rem;
  color: #fff;
  border-radius: 0.5rem;
  background-color: #ff410f;
}
.changepass {
  width: 175px;
  height: 36px;
  border: 1px solid #BCBCBC;
  text-indent: 20px;
}
    .DiamondList-main{ width: 100%; padding: 0.3rem 0.26rem 0.01rem; }
    .personal-options-extend{ position: absolute; top: 0; right: 0; bottom: 0; left: 0; background-color: rgba(255,255,255,1); }
    .personal-options-extend .extend-from{ padding-top: 12px; padding-right: 10px; padding-left: 10px; }
    .personal-options-extend .extend-from-container{ overflow: hidden; font-size: 14px; position: relative; padding-bottom: 10px; padding-top: 15px; }
    .personal-options-extend .extend-from-container::after{ content: ''; position: absolute; right: 0px; bottom: 0; left: 0px; height: 1px; overflow: hidden; background-color: #E5E5E5; }
    /*.personal-options-extend .extend-from-container:last-child::after{ display: none; }*/
    .personal-options-extend .extend-from-headline{ height: 50px; line-height: 50px; }
    .personal-options-extend .extend-from-title{ height: 20px; line-height: 20px; color: #B5B6CA; }
    .personal-options-extend .extend-from-container input{ width: 100%; height: 30px; line-height: 30px; border: 0; background-color: transparent; outline: none; }
    .extend-from-button{  height: 36px; line-height: 36px; float: right; color: #B5B6CA; margin-right: 20px; }
    .extend-from-notes{  text-align: left; padding: 0 30px 20px;  color: #B5B6CA; font-size: 14px; }
    .personal-options-extend .extend-button-container{ padding-top: 70px; text-align: center; font-size: 16px; }
    .extend-button{ display: block; width: 100%; height: 40px; line-height: 40px; text-align: center; background-color: #CCCCCC; color: #FFF; border-radius: 25px; border: 1px solid transparent; }
    .extend-button.active{ border-color: #FF6068; background: linear-gradient(#FE4B4B, #E81B16); }
    .personal-options-extend .extend-button-container .extend-button.ignore{ margin-bottom: 8px; background-color: transparent; color: #FF6068; }

    .personal-options-extend .extend-from-code{ position: relative; font-size: 16px; border-bottom: 1px solid #E5E5E5; padding-bottom: 15px; padding-top: 12px; text-align: center; }
    .personal-options-extend .extend-from-code input{ border: 0; text-align: center; background-color: transparent; width: 100%; height: 25px; line-height: 25px; outline: none; }
    .personal-options-extend.personal-options-sex{ background-color: transparent; text-align: center; }
    .personal-options-extend .extend-select{ width: 200px; height: 120px; position: absolute; top: 50%; left: 50%; margin-top: -60px; margin-left: -100px; overflow: hidden; background-color: #FFF; border-radius: 6px; }
    .personal-options-extend .extend-select-headline{ height: 40px; line-height: 40px; color: #B5B6CA; background-color: #FAFAFA; border-bottom: 1px solid #E5E5E5; }
    .personal-options-extend .extend-select-col{ height: 40px; line-height: 40px; overflow: hidden; position: relative; }
    .personal-options-extend .extend-select-col::after{ content: ''; position: absolute; right: 0px; bottom: 0; left: 0px; height: 1px; overflow: hidden; background-color: #E5E5E5; }
    .personal-options-extend .extend-select-col:last-child::after{ display: none; }
</style>



// WEBPACK FOOTER //
// src/components/ChangePass.vue